// Public classes.
export {
  ContainerRef,
  InfiniteScrollEvent,
  IPositionElements,
  IPositionStats,
  IResolver
} from './models';

export { InfiniteScrollDirective } from './modules/infinite-scroll.directive';
export { InfiniteScrollModule } from './modules/ngx-infinite-scroll.module';
